import { render, staticRenderFns } from "./BookArticle.vue?vue&type=template&id=09344cc2&"
import script from "./BookArticle.vue?vue&type=script&lang=js&"
export * from "./BookArticle.vue?vue&type=script&lang=js&"
import style0 from "./BookArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09344cc2')) {
      api.createRecord('09344cc2', component.options)
    } else {
      api.reload('09344cc2', component.options)
    }
    module.hot.accept("./BookArticle.vue?vue&type=template&id=09344cc2&", function () {
      api.rerender('09344cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/運勢書2024/BookArticle.vue"
export default component.exports